<script setup lang="ts">
import { computed } from "vue";
import { usePrice } from "@/composables/usePrice";

const { getFormattedPrice, currencyCode } = usePrice();
const props = defineProps<{
  value: number | undefined;
  classes?: string;
  unformatted?: boolean;
}>();

const getPrice = computed<string>(() => getFormattedPrice(props.value, props.unformatted));
</script>

<template>
  <span :class="classes">
    <slot name="beforePrice" /> {{ getPrice }} <slot name="afterPrice" />
  </span>
</template>